import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getAnalyticsConfig } from '../lib/analytics';

const KEY = 'gotalottery.analytics.notice.dismissed';

export default function AnalyticsNotice() {
  const [visible, setVisible] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => {
    if (localStorage.getItem(KEY)) return;
    void getAnalyticsConfig().then(config => {
      if (config.ga4MeasurementId || config.clarityProjectId) setVisible(true);
    });
  }, []);
  if (!visible || pathname.startsWith('/admin') || pathname.startsWith('/AdminScreen')) return null;
  return (
    <aside
      className='fixed inset-x-3 bottom-3 z-50 mx-auto max-w-2xl rounded-xl border border-zinc-200 bg-white p-4 text-sm text-zinc-800 shadow-xl'
      aria-label='Aviso de analítica'
    >
      <p>
        Usamos herramientas de analítica para entender las visitas y mejorar esta página.
        <Link to='/privacidad' className='ml-1 underline'>
          Política de Privacidad
        </Link>
      </p>
      <button
        type='button'
        className='mt-2 rounded-lg bg-zinc-900 px-3 py-1.5 text-white'
        onClick={() => {
          localStorage.setItem(KEY, '1');
          setVisible(false);
        }}
      >
        Entendido
      </button>
    </aside>
  );
}
